
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import Logout from './pages/Logout';
import MainMenu from './pages/MainMenu';
import Profile from './pages/Profile';
import PointCollect from './pages/PointCollect';
import UserInput from './pages/UserInput';
import PointRedeem from './pages/PointRedeem';
import CouponDescription from './pages/CouponDescription';
import PointHistory from './pages/PointHistory';
import MyCoupon from './pages/MyCoupon';
import CouponUsed from './pages/CouponUsed';
import CountDown from './pages/CountDown';
import PointCheck from './pages/PointCheck';
import PointCheckMenu from './pages/PointCheckMenu';
import TermAndConditions from './pages/TermAndConditions';
import PrivacyAndPolicy from './pages/PrivacyAndPolicy';
import PurchaseHistory from './pages/PurchaseHistory';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/main-menu" element={<MainMenu />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/point-collect" element={<PointCollect />} />
          <Route path="/user-input" element={<UserInput />} />
          <Route path="/point-redeem" element={<PointRedeem />} />
          <Route path="/coupon-description" element={<CouponDescription />} />
          <Route path="/point-history" element={<PointHistory />} />
          <Route path="/my-coupon" element={<MyCoupon />} />
          <Route path="/coupon-use" element={<CouponUsed />} />
          <Route path="/countdown" element={<CountDown />} />
          <Route path="/point-check" element={<PointCheck />} />
          <Route path="/admin" element={<PointCheckMenu />} />
          <Route path="/term-and-conditions" element={<TermAndConditions />} />
          <Route path="/privacy-and-policy" element={<PrivacyAndPolicy />} />
          <Route path="/purchase-history" element={<PurchaseHistory />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
